import { render } from "./ColorAlpha.vue?vue&type=template&id=2900f2ed"
import script from "./ColorAlpha.vue?vue&type=script&lang=js"
export * from "./ColorAlpha.vue?vue&type=script&lang=js"

import "./ColorAlpha.vue?vue&type=style&index=0&id=2900f2ed&lang=css"

import exportComponent from "/dev/shm/repo/airmap-2s5z7ythbr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__